/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { communicationsHorizontalNavEntrypoint } from '@atlassian/jira-communications-horizontal-nav/entrypoint.tsx';
import { communicationsStakeholderGroupsEntrypoint } from '@atlassian/jira-communications-stakeholder-groups/entrypoint.tsx';

export const stakeholderGroupsPageEntryPoint = createPageEntryPoint({
	main: communicationsStakeholderGroupsEntrypoint,
	topNavigationMenuId: MENU_ID.COMMUNICATIONS,
	horizontalNavigation: communicationsHorizontalNavEntrypoint,
});
